import React from 'react'

function AccessToggle({ params, setParams }) {
  return (
    <div className="form-check form-switch mt-1">
      <input
        className="form-check-input"
        type="checkbox"
        id="active"
        checked={params.hideNoAccess}
        onChange={() =>
          setParams({ ...params, hideNoAccess: !params.hideNoAccess })
        }
      />
      <label className="form-check-label" htmlFor="active">
        Hide No Access
      </label>
    </div>
  )
}

export default AccessToggle
